module.exports = __webpack_public_path__ + "static/media/columnImageRight.e7117556.png";